import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f3246a68"
import script from "./addEditQueryAssignment.js?vue&type=script&lang=js&external"
export * from "./addEditQueryAssignment.js?vue&type=script&lang=js&external"
import style0 from "./addEditQueryAssignment.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports